function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pack",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M316.96,424.4A96,96,0,1,1,400,472.22,95.391,95.391,0,0,1,316.96,424.4Z",
    style: {
      fill: "#6fe3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,135.55V280.22A96.008,96.008,0,0,0,316.96,424.4L208,487.3V246.38L399.98,135.54Z",
    style: {
      fill: "#c16752"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208 246.38 141.14 207.78 333.13 96.94 399.98 135.54 208 246.38",
    style: {
      fill: "#e48e66"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.13 96.94 141.14 207.78 92.21 179.53 284.19 68.69 333.13 96.94",
    style: {
      fill: "#e5d45a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208 24.7 284.19 68.69 92.21 179.53 92.2 179.53 16.02 135.54 208 24.7",
    style: {
      fill: "#af593c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208 246.38 208 487.3 16 376.45 16 135.55 16.02 135.54 92.2 179.53 92.2 339.28 115.45 329.68 140.8 358.48 140.8 207.98 141.14 207.78 208 246.38",
    style: {
      fill: "#e48e66"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.14 207.78 140.8 207.98 140.8 358.48 115.45 329.68 92.2 339.28 92.2 179.53 92.21 179.53 141.14 207.78",
    style: {
      fill: "#f8ec7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,273.463V135.55a7.03,7.03,0,0,0-3.54-6.083L211.5,18.638a7,7,0,0,0-7,0L12.628,129.415A7,7,0,0,0,9,135.55v240.9a7,7,0,0,0,3.5,6.062l192,110.85a7,7,0,0,0,7,0l103.122-59.53A103,103,0,1,0,407,273.463ZM99,191.648l35,19.976V339.933l-13.195-14.878a7.229,7.229,0,0,0-8.076-1.845L99,328.816Zm7.21-12.118L284.191,76.772l34.935,20.17L141.141,199.7Zm226.916-74.5L385.98,135.54,208,238.3l-52.859-30.518ZM215,250.421,393,147.653v125.81a103.015,103.015,0,0,0-85.413,148.264L215,475.176ZM208,32.783l62.191,35.906L92.206,171.449,30.02,135.541ZM23,147.654l62,35.917V339.28a7.136,7.136,0,0,0,9.822,6.47l18.652-7.691,22.059,25.046a7.01,7.01,0,0,0,5.262,2.375,7.553,7.553,0,0,0,2.573-.451A7.094,7.094,0,0,0,148,358.48V219.707l53,30.714V475.176L23,372.409ZM400,465.22a89,89,0,1,1,89-89A89.32,89.32,0,0,1,400,465.22Z",
    style: {
      fill: "#63316d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.854,293.881a7.185,7.185,0,0,0,6.292-3.687L255,283.247V343.42a7,7,0,1,0,14,0V273.051l5.69,6.155a6.929,6.929,0,0,0,9.836.284,7,7,0,0,0,.254-9.9l-17.915-18.96a7.011,7.011,0,0,0-11.267,1.491l-16.9,31.44a7,7,0,0,0,6.158,10.316Z",
    style: {
      fill: "#63316d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,338.45a7,7,0,0,0-7,7v25.92a7,7,0,0,0,14,0V345.45A7,7,0,0,0,41,338.45Z",
    style: {
      fill: "#63316d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,357.65a7,7,0,0,0-7,7V388a7,7,0,0,0,14,0V364.65A7,7,0,0,0,69,357.65Z",
    style: {
      fill: "#63316d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,376.85a7,7,0,0,0-7,7v20.56a7,7,0,0,0,14,0V383.85A7,7,0,0,0,98,376.85Z",
    style: {
      fill: "#63316d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,396.05a7,7,0,0,0-7,7v17.77a7,7,0,0,0,14,0V403.05A7,7,0,0,0,126,396.05Z",
    style: {
      fill: "#63316d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,415.25a7,7,0,0,0-7,7v15.36a7,7,0,0,0,14,0V422.25A7,7,0,0,0,155,415.25Z",
    style: {
      fill: "#63316d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.16,353.467l-31.89,18.41a7,7,0,1,0,7,12.125l31.89-18.41a7,7,0,1,0-7-12.125Z",
    style: {
      fill: "#63316d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.582,343.62l-61.5,50.035-18.761-21.979a7,7,0,1,0-10.648,9.089l23.2,27.179a7,7,0,0,0,9.742.886l66.8-54.351a7,7,0,1,0-8.836-10.859Z",
    style: {
      fill: "#63316d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp);
export default __webpack_public_path__ + "static/media/mp.41b1b840a448bf6539d93857cbf1c653.svg";
export { ForwardRef as ReactComponent };